import {
  getDiscountPrice,
  getCurrencyCode,
  getCountryCode,
  getListProductVariant,
} from "./helpers";

const sendEvent = (event) => {

  if (isDataLayerAvailable()) {
    window.dataLayer.push(event);
  }
  // LOG ALWAYS
  //else {
    console.log(event.event, event.eventAction, event);
  //}
};

const getCurrency = () => {
  if (isDataLayerAvailable()) {
    return window.dataLayer[0].currency;
  } else {
    return null;
  }
};

const getCurrencySymbol = () => {
  if (isDataLayerAvailable()) {
    return window.dataLayer[0].currencySymbol;
  } else {
    return null;
  }
};

const isDataLayerAvailable = () => {
  return window.dataLayer && window.dataLayer.push;
};

const isBundlePage = () => {
  const pageType =
    document.getElementById("root").getAttribute("data-page-type") ||
    "bundle-group";
  return pageType === "bundle-group";
};

const getViewId = () => {
  return document.querySelector("#root").getAttribute("data-view-id");
};

const getCoupon = (bundle) => {
  if (!isBundlePage()) {
    return undefined;
  }
  let name = bundle.name;
  if (bundle?.translations && getViewId() in bundle?.translations) {
    name = bundle.translations[getViewId()];
  }
  return `${bundle.discount}% OFF ${name}`;
};

const getEventCategory = () => {
  return isBundlePage() ? "Product Bundles" : "Explore Collection";
};

const mapProductData = (product, bundle) => {
  let stockStatus = undefined;
  /*   if(product?.variants.length){
    stockStatus = product.variants.reduce((acc, curr) => {
      if(curr.id.includes(product?.variant ? `${product.sku}:${product.variant}` : product.sku)){
        return {...acc, [curr.id]:curr.productInventoryState}
      }else{
        return acc
      }
    },{})
  } */

  const originalPrice = parseFloat(parseFloat(product.finalPrice).toFixed(2));
  return {
    availSizes: product?.availSizes || [],
    list: getEventCategory(),
    category: getEventCategory(),
    avgRating: product?.avgRating?.score,
    badge: undefined, // ???????
    brand: "THENORTHFACE-" + getCountryCode(),
    bundleId: bundle.cross_bundle_id || bundle.id,
    catalogCategory: undefined,
    colorCode: product.colorCode,
    colorDescription: product.colorDescription,
    discountType: undefined,
    id: product.id,
    masterId: product.masterId,
    merchProductId: product.id,
    name: product.name,
    numReviews: product?.avgRating?.reviewsCount,
    onSale: false,
    saleDiscountAmount: 0,
    onCoupon: isBundlePage(),
    coupon: getCoupon(bundle),
    couponType: isBundlePage() ? "AUTO" : undefined,
    couponDiscountAmount: parseFloat(
      parseFloat(originalPrice - product.price).toFixed(2),
    ),
    originalPrice,
    position: undefined,
    price: product.price,
    searchTerm: undefined,
    styleCode: product.id.substring(2, 8),
    taxTotal: undefined,
    variant: product.variant,
    stockStatus,
  };
};

const getProductsFromBundles = (bundles, initialIndex, productsList) => {
  const combinedBundles = [];
  for (const index in bundles) {
    const item = bundles[index];
    if (item.bundles) {
      combinedBundles.push(...item.bundles);
    } else {
      combinedBundles.push(item);
    }
  }
  return combinedBundles.reduce((acc, bundle, bundleIndex) => {
    let data = {};
    let products = [];
    try {
      if (typeof bundle.data !== "object" && !Array.isArray(bundle.data)) {
        data = JSON.parse(bundle.data || "{}");
      } else {
        data = bundle.data;
      }
      if (
        typeof bundle.products !== "object" &&
        !Array.isArray(bundle.products)
      ) {
        products = JSON.parse(bundle.products || "[]");
      } else {
        products = bundle.products;
      }
    } catch (e) {
      console.error("Error parsing JSON for bundle:", bundle, e);
      return acc;
    }

    const impressionProducts = products.map((product, productIndex) => {
      const prepend =
        data.ids[product.sku]?.substring(0, 2) +
        data.ids[product.sku]?.substring(3, 5);
      
      //Added to solve issue 
      let colorCode =
        product.variant || product.fallback
      if(typeof colorCode === undefined){
        colorCode = product.variant || data?.fallback_variants?.[product.sku];
      }
          

      const fullProductData = productsList.find((p) =>
        p.id.includes(
          product?.fallback
            ? `${product.sku}:${product.fallback}`
            : product.sku,
        ),
      );

      const couponDiscount = bundle?.discount || 0; //percentage

      const originalPrice = fullProductData?.price || undefined;
      const couponDiscountAmount = originalPrice && couponDiscount > 0 ? originalPrice * (couponDiscount / 100) : 0
      const price = originalPrice && couponDiscountAmount ? originalPrice - couponDiscountAmount : originalPrice

      ++initialIndex;
      return {
        list: getEventCategory(),
        onSale: false,
        saleDiscountAmount: 0,
        onCoupon: isBundlePage(),
        coupon: getCoupon(bundle),
        couponType: isBundlePage() ? "AUTO" : undefined,
        couponDiscountAmount,
        category: getEventCategory(),
        bundleId: bundle.cross_bundle_id || bundle.id,
        colorCode,
        id: `${prepend}${product.sku}${colorCode}`,
        //masterId: `${product.prepend}${product.sku}`,
        //merchProductId: `${product.prepend}${product.sku}${product.variant || ""}`,
        position: productIndex + 1,
        brand: "THENORTHFACE-" + getCountryCode(),
        avgRating: undefined,
        badge: undefined,
        catalogCategory: undefined,
        colorDescription: undefined,
        discountType: undefined,
        name: fullProductData?.product_name_trim || undefined,
        numReviews: undefined,
        originalPrice,
        price,
        searchTerm: undefined,
        styleCode: undefined,
        taxTotal: undefined,
        variant: undefined,
      };
    });
    return [...acc, ...impressionProducts];
  }, []);
};

export const onExperienceStart = () => {
  const event = {
    event: "loadEventData",
    eventCategory: getEventCategory(),
    eventAction: "Experience Start",
    eventLabel: "Step 1 - Load Bundles",
    nonInteractive: true,
    customMetrics: {},
    customVariables: {},
    _clear: true,
  };

  return sendEvent(event);
};

export const onSelectSize = (size, bundle, product) => {
  const event = {
    event: "loadEventData",
    eventCategory: getEventCategory(),
    eventAction: "Select Size",
    eventLabel: `${bundle.name} - ${product.id} - ${size}`,
    nonInteractive: true,
    customMetrics: {},
    customVariables: {
      bundleId: bundle.cross_bundle_id || bundle.id,
    },
    _clear: true,
  };

  return sendEvent(event);
};

export const onGoToBundle = (bundle, data, prices) => {
  try {
    const dataToUse = typeof data !== 'object' ? JSON.parse(data) : data

    //check if parse is needed.
    const products = typeof bundle.products !== 'object' ? JSON.parse(bundle.products) : bundle.products;
    products.map((product, index) => {

      product.prepend =
        dataToUse.ids[product.sku].substring(0, 2) +
        dataToUse.ids[product.sku].substring(3, 5);
      product.bundleId = bundle.id;
      product.variant = getListProductVariant(
        undefined,
        product.fallback,
        dataToUse?.fallback_variants?.[product.sku],
      );
      const fullProductData = prices.find((p) =>
        p.id.includes(
          product?.fallback
            ? `${product.sku}:${product.fallback}`
            : product.sku,
        ),
      );
      productClick(product, bundle, fullProductData);
      console.log("productClick");
    });
  } catch (e) {}


  const event = {
    event: "loadEventData",
    eventCategory: getEventCategory(),
    eventAction: "Step Completed",
    eventLabel: "Step 1 - Load Bundles",
    nonInteractive: false,
    customMetrics: {},
    customVariables: {
      bundleId: bundle.id,
    },
    _clear: true,
  };
  return sendEvent(event);
};

export const onGoToNextProduct = (
  bundleId,
  originalPrice,
  discountPercentage,
  step,
) => {
  const event = {
    event: "loadEventData",
    eventCategory: getEventCategory(),
    eventAction: "Step Completed",
    eventLabel: "Step 2 - Shop Bundle",
    nonInteractive: false,
    customMetrics: {},
    customVariables: {
      bundleId,
    },
    _clear: true,
  };
  return sendEvent(event);
};

const nextProductCompleted = (bundle) => {
  const event = {
    event: "loadEventData",
    eventCategory: getEventCategory(),
    eventAction: "Step Completed",
    eventLabel: "Step 3 - Next Product",
    nonInteractive: false,
    customMetrics: {},
    customVariables: {
      bundleId: bundle.cross_bundle_id || bundle.id,
    },
    _clear: true,
  };
  return sendEvent(event);
};

export const addToCart = (products, bundle, stepIndex) => {
  return nextProductCompleted(bundle);
  const event = {
    event: "addToCart",
    ecommerce: {
      currencyCode: getCurrencyCode(),
      add: {
        products: products.map((product) => {
          product.fullProduct.finalPrice = product.finalPrice;
          product.fullProduct.price = getDiscountPrice(
            product.finalPrice,
            bundle.discount,
          );
          const p = mapProductData(product.fullProduct, bundle);
          return {
            ...p,
            quantity: 1,
            size: product.size,
            colorCode: product.colorCode,
            variant: product.colorCode,
            colorDescription: product.colorDescription,
            name: product.name,
            price: product.price,
            id: product.id.replaceAll(":", ""),
            masterId: product.id.split(":")[0] + product.id.split(":")[1],
            merchProductId:
              product.id.split(":")[0] +
              product.id.split(":")[1] +
              product.id.split(":")[2],
          };
        }),
      },
    },
    customMetrics: {},
    customVariables: {
      bundleId: bundle.id,
    },
    _clear: true,
  };
  return sendEvent(event);
};

export const productDetailView = (product, bundle, stepIndex, variants) => {
  product.variants = variants;
  const event = {
    event: "productDetailView",
    eventCategory: getEventCategory(),
    eventAction: "Product Detail View",
    eventLabel: `${product.partNumber.replace(":", "")}${product.colorCode}`,
    nonInteractive: true,
    ecommerce: {
      currencyCode: getCurrencyCode(),
      detail: {
        actionField: {
          viewType: "View details",
        },
        products: [mapProductData(product, bundle)],
      },
    },
    customMetrics: {
      bundleValue: getDiscountPrice(bundle.price, bundle.discount),
      bundleOriginalValue: bundle.price,
    },
    customVariables: {
      bundleId: bundle.cross_bundle_id || bundle.id,
    },
    _clear: true,
  };
  return sendEvent(event);
};

export const productImpressions = (bundles, initialIndex, productsList) => {
  const products = getProductsFromBundles(bundles, initialIndex, productsList);
  if (!products.length) {
    return;
  }
  const chunkSize = 24;
  for (let i = 0; i < products.length; i += chunkSize) {
    const chunk = products.slice(i, i + chunkSize);
    const event = {
      event: "productImpressions",
      eventCategory: getEventCategory(),
      eventAction: "Product Impressions",
      nonInteractive: true,
      ecommerce: {
        currencyCode: getCurrencyCode(),
        impressions: {
          products: chunk,
        },
      },
      customVariables: {},
      _clear: true,
    };
    sendEvent(event);
  }
};

export const productClick = (product, bundle, fullProductData) => {
  const colorCode = product.variant || undefined;
  const event = {
    event: "productClick",
    eventCategory: getEventCategory(),
    eventAction: "Product Clicks",
    eventLabel: `${product.prepend}${product.sku}`, // PrO
    ecommerce: {
      currencyCode: getCurrencyCode(),
      click: {
        products: [
          {
            list: getEventCategory(),
            brand: "THENORTHFACE-" + getCountryCode(),
            onSale: false,
            saleDiscountAmount: 0,
            discountType: undefined,
            onCoupon: isBundlePage(),
            coupon: getCoupon(bundle),
            couponType: isBundlePage() ? "AUTO" : undefined,
            category: getEventCategory(),
            bundleId: product.bundleId,
            colorCode,
            id: `${product.prepend}${product.sku}${colorCode}`,
            masterId: `${product.prepend}${product.sku}`,
            merchProductId: `${product.prepend}${product.sku}${product.variant || ""}`,
            avgRating: undefined,
            badge: undefined,
            catalogCategory: undefined,
            colorDescription: undefined,
            name: fullProductData?.product_name_trim || undefined,
            numReviews: undefined,
            originalPrice: undefined,
            price: fullProductData?.price || undefined,
            searchTerm: undefined,
            styleCode: undefined,
            taxTotal: undefined,
            variant: undefined,
          },
        ],
      },
    },
    customVariables: {
      bundleId: product.bundleId,
    },
  };

  return sendEvent(event);
};

// NOT USED EVENTS

export const onApplyFilter = (filterName) => {
  return;
  const event = {
    event: "loadEventData",
    eventCategory: "PDP",
    eventAction: "Product Bundle_Apply Filter",
    eventLabel: filterName,
    nonInteractive: false,
    customMetrics: {},
    customVariables: {
      functionality: "Product Bundle",
    },
    _clear: true,
  };
  return sendEvent(event);
};

export const colorVariantChange = (sku, colorDesc) => {
  return;
  const event = {
    event: "loadEventData",
    eventCategory: "PDP",
    eventAction: "Color Click",
    eventLabel: `${sku} - ${colorDesc}`, // eg."NF0A4R2A: Men’s Apex Bionic Jacket",
    nonInteractive: false,
    customMetrics: {},
    _clear: true,
    customVariables: {
      functionality: "Product Bundle",
    },

  };
  return sendEvent(event);
};

